import { defineComponent as t, computed as l, createElementBlock as a, openBlock as m, normalizeStyle as n, normalizeClass as i } from "vue";
import { tw as o } from "../../utils/tailwind.js";
const p = /* @__PURE__ */ t({
  name: "RevColorSwatch",
  __name: "ColorSwatch",
  props: {
    color: {},
    size: { default: "medium" }
  },
  setup(r) {
    const s = l(() => ({
      small: o`size-12`,
      medium: o`size-16`
    })[r.size]);
    return (e, c) => (m(), a("div", {
      class: i(["border-static-default-dim rounded-md m-2 border-1", s.value]),
      style: n({ backgroundColor: e.color })
    }, null, 6));
  }
});
export {
  p as default
};
